import { THEME_IDS } from '@accedo/vdkweb-ui/lib/components/Menu';
import * as menu from './menu.scss';

/*
 * Create the theme object for overriding
 * component styles
 */
export default {
  [THEME_IDS.Menu]: menu,
  [THEME_IDS.MenuItem]: menu
};
